import React, { useRef, useState, useEffect } from "react";
import Navigation from "../partials/navigation";
import Footer from "../partials/footer";
import { Helmet } from "react-helmet";
import { appName } from "../app.json";
import AuthProvider from "../providers/Auth.Provider";
import Image from "../partials/Image";
import { getValueFromHref } from "../util/getValueFromHref";
import AlertMessage from "../partials/alertMessage";
import LoadingSpinner from "../partials/loading";
import { Staff, REMOVE_STAFF } from "../queries/staff.query";
import { REMOVE_PATIENT } from "../queries/patient.query";
import { useMutation } from "react-apollo";

const ConfirmRemoval = ({ history }) => {
    const title = "Confirm your account password";
    const { GetToken, GetAuthenticatedStaff, IsAuthenticationError, LogOut } = AuthProvider.authProvider;
    const { email, name, image } = GetToken() && GetAuthenticatedStaff();
    const [msg, setMessage] = useState({});
    // local ref
    const passwordRef = useRef();

    // param
    const _path = getValueFromHref("pathname");
    const _funcTarget = getValueFromHref("func");
    const _ref = getValueFromHref("ref");
    // Mutations
    const [loginFunc, { loading: lLoading }] = useMutation(Staff.MUTATION.LOGIN, {
        onError: err => {
            setMessage({
                message: err.message,
                status: true
            });
        },
        onCompleted: async data => {
            if (data.Login.token) {
                // remove staff or patient
                if (_funcTarget.toLowerCase() === "staff") {
                    await staffRemoveFunc({
                        variables: { id: _ref }
                    });
                } else if (_funcTarget.toLowerCase() === "patient") {
                    await patientRemoveFunc({
                        variables: { id: _ref }
                    });
                } else {
                    setMessage({
                        message: "Unknown operation!",
                        status: true
                    });
                }
            }
        }
    });
    const [patientRemoveFunc, { loading: pLoading }] = useMutation(REMOVE_PATIENT, {
        onError: err => {
            setMessage({
                message: err.message,
                status: true
            });
        },
        onCompleted: data => {
            if (data.DeletePatient) {
                setMessage({
                    message: data.DeletePatient.message,
                    status: false
                });
                setTimeout(() => {
                    history.goBack();
                }, 1000);
            }
        }
    });
    const [staffRemoveFunc, { loading: sLoading }] = useMutation(REMOVE_STAFF, {
        onError: err => {
            setMessage({
                message: err.message,
                status: true
            });
        },
        onCompleted: data => {
            if (data.DeleteStaff) {
                setMessage({
                    message: data.DeleteStaff.message,
                    status: false
                });
                setTimeout(() => {
                    history.goBack();
                }, 1000);
            }
        }
    });
    // check for auth error
    useEffect(() => {
        if (msg.message && IsAuthenticationError(msg.message)) {
            LogOut();
            history.push("/login");
        }
    }, [LogOut, msg, IsAuthenticationError, history]);

    if (_path && _funcTarget && _ref) {
        return (
            <>
                <Helmet>
                    <title>
                        {title} | {appName}
                    </title>
                </Helmet>
                <div className="page-wrapper">
                    <Navigation />

                    <div className="page-container">
                        <div className="page-content-wrapper page-content-wrapper-home">
                            <div className="page-content page-content-home">
                                <div className="row justify-content-center">
                                    <div className="col-md-5 col-lg-4 col-12">
                                        <div className="card" style={{ minHeight: "200px" }}>
                                            <div className="card-head">
                                                <button
                                                    onClick={() => {
                                                        history.goBack();
                                                    }}
                                                    title="Back"
                                                    className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                                >
                                                    <i className="material-icons text-primary">keyboard_backspace</i>
                                                </button>
                                            </div>
                                            <div className="card-body margin-top-10 margin-bottom-20">
                                                <center>
                                                    <Image alt={name} src={image} />
                                                    <h4>{name}</h4>

                                                    <form
                                                        onSubmit={async evt => {
                                                            evt.preventDefault();
                                                            setMessage({});
                                                            await loginFunc({
                                                                variables: {
                                                                    email,
                                                                    password: passwordRef.current.value
                                                                }
                                                            });
                                                        }}
                                                    >
                                                        <div className="form-group margin-top-5">
                                                            {/* <label htmlFor="password-id">
																Enter password
																to continue
															</label> */}
                                                            <input
                                                                type="password"
                                                                className="form-control input-height"
                                                                id="password-id"
                                                                required
                                                                ref={passwordRef}
                                                                placeholder="Enter password"
                                                                aria-describedby="password-id"
                                                            />
                                                            {_funcTarget === "staff" && <small className="text-warning">Enter password to confirm staff's record removal</small>}
                                                            {_funcTarget === "patient" && <small className="text-warning">Enter password to confirm patient's record removal</small>}
                                                        </div>
                                                        <div className="form-group text-right">
                                                            <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 m-t-20 btn-circle btn-success">
                                                                Submit
                                                                <i className="material-icons">keyboard_arrow_down</i>
                                                            </button>
                                                        </div>
                                                    </form>
                                                </center>
                                                <AlertMessage message={msg.message} failed={msg.status} />
                                                <LoadingSpinner loading={sLoading || pLoading || lLoading} bar={true} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        );
    }
    return history.goBack();
};

export default ConfirmRemoval;
